import { createSelector, createSlice } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import { PURGE } from 'redux-persist';
const defaultState = {
  isPocModeActive: false
};

const pocToggleSlice = createSlice({
  name: 'pocToggle',
  initialState: defaultState,
  reducers: {
    togglePoc: (state) => {
      state.isPocModeActive = !state.isPocModeActive;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, (state) => {
      return defaultState;
    });
  }
});

const selectSelf = (state: RootState) => state.pocToggle;

export const selectIsPOCModeActive = createSelector(
  selectSelf,
  (state) => state.isPocModeActive
);

const { actions, reducer } = pocToggleSlice;

export const { togglePoc } = actions;

export default reducer;
